/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadAppConfig } from './app/util/app-config';

if (environment.production) {
  enableProdMode();
}

// The API host is a per-deployment value, fetched before bootstrap rather than
// compiled in -- see app/util/app-config.ts for why. SharedService.apiUrl and
// AuthInterceptor.isTrustedApiUrl read it synchronously, so it has to be
// resolved before any component can issue a request.
//
// loadAppConfig never rejects: a missing or malformed file falls back to the
// compiled default, so the application always starts.
loadAppConfig()
  .then(() =>
    platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], preserveWhitespaces: true,})
  )
  .catch(err => console.error(err));
